import { defineMessages } from 'react-intl';
import type { MessageDescriptor } from 'react-intl';

type MessageKey =
  | 'formsFooterMessage'
  | 'formsFooterWithEnterpriseMessage'
  | 'fileRequestFooterMessage'
  | 'termOfServiceLink'
  | 'privacyNoticeLink'
  | 'learnMoreLink'
  | 'separator';

const messages: Record<MessageKey, MessageDescriptor> = defineMessages({
  formsFooterMessage: {
    id: 'boxFormsSubmissionPage.forms.footer.message',
    description: 'Message for forms footer',
    defaultMessage:
      'Before submitting, please be sure you trust this site, have the rights to the data, and want to share this content to the owner of this form.',
  },
  formsFooterWithEnterpriseMessage: {
    id: 'boxFormsSubmissionPage.forms.footer.messageWithEnterprise',
    description: 'Message for forms footer',
    defaultMessage:
      'Before submitting, please be sure you trust this site, have the rights to the data, and want to share this content to the owner of this form ({enterprise}).',
  },
  fileRequestFooterMessage: {
    id: 'boxFormsSubmissionPage.filerequest.footer.message',
    description: 'Message for file request footer',
    defaultMessage:
      'Before submitting, please be sure you trust this site, have the rights to the data, and want to share this content to the owner of this file request.',
  },
  termOfServiceLink: {
    id: 'boxFormsSubmissionPage.footer.termOfServiceLink',
    description: 'Link label for Terms of Service',
    defaultMessage: 'Box Terms of Service',
  },
  privacyNoticeLink: {
    id: 'boxFormsSubmissionPage.footer.privacyNoticeLink',
    description: 'Link label for Privacy Notice',
    defaultMessage: 'Box Privacy Notice',
  },
  learnMoreLink: {
    id: 'boxFormsSubmissionPage.footer.learnMoreLink',
    description: 'Link label for learning more about Forms',
    defaultMessage: 'Learn More',
  },
  separator: {
    id: 'boxFormsSubmissionPage.footer.separator',
    description: 'Separator',
    defaultMessage: '|',
  },
});

export default messages;
